"use client";

import ViuGoOddsMatchCell from "./ViuGoOddsMatchCell";

export default function ViuGoOddsMatchOuCell({
    line,
    side,
    odds,
    trend,
    labelClassName,
    valueClassName,
}) {
    const label = side === "O" ? (line ?? "") : " U";
    return (
        <ViuGoOddsMatchCell
            label={label}
            value={odds}
            trend={trend}
            labelClassName={labelClassName}
            valueClassName={valueClassName}
        />
    );
}

